import {lazy} from 'react';

import FeedbackButton from './FeedbackButton';

const FeedbackForm = lazy(() => import('./FeedbackForm'));


export {
    FeedbackButton,
    FeedbackForm
};
